import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PayableUpdateComponent } from '../payable-update/payable-update.component';

export interface PayableUpdateDialogInput {
    payableId: number;
}

export interface PayableUpdateDialogResult {
    success?: boolean;
    payableId?: number;
}

@Component({
    selector: 'app-payable-update-dialog',
    templateUrl: './payable-update-dialog.component.html',
    standalone: true,
    imports: [PayableUpdateComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PayableUpdateDialogComponent {
    @Input() open = false;
    @Input() payableId: number;
    @Output() readonly closed = new EventEmitter<PayableUpdateDialogResult | null>();

    @ViewChild('payableDetailForm') payableDetailForm: PayableUpdateComponent;

    isLoading: boolean = true;

    onLoadingStateChange(isLoading: boolean): void {
        this.isLoading = isLoading;
    }

    onFormSubmitted(): void {
        this.closed.emit(<PayableUpdateDialogResult>{ success: true, payableId: this.payableId });
    }

    submit(): void {
        this.payableDetailForm?.onSubmit();
    }

    cancel(): void {
        this.closed.emit(null);
    }
}
